<template>
  <v-dialog justify="center" :value="value" persistent max-width="400">
    <v-card color=#fafafa>
      <section class="ma-0 pa-6">
        <v-row justify="center">
          <v-icon x-large color="red">mdi-trash-can-outline</v-icon>
        </v-row>
        <v-row justify="center">
            <span class='pa-4'>
            Delete the selected recap addition?
            </span>
            <span class='pa-4'>
            Last Updated: {{formatDateTime(selectedRecapAddition.updated_on)}}
            </span>
            <span class='pa-4'>
            Warning: This action cannot be undone. Deletion of this recap addition record means it will not be reflected on the next retailer period statement.
            </span>
        </v-row>
        <v-row justify="center" class="pa-4">
          <v-btn text height="40" @click.stop="$emit('update:value', false)">
            Cancel
          </v-btn>
          <v-btn color="#0c67a5" height="40" class="white--text ml-4" @click="deleteRecapAddition(selectedRecapAddition.recap_addition_id)">
            Confirm
          </v-btn>
        </v-row>
      </section>
    </v-card>
  </v-dialog>
</template>

<script>
import RecapAdditions from '@/axios/recap-additions'
import { dateFormat } from '@/mixins/date-format'
export default {
  name: 'DeleteRecapAddition',
  props: [
    'value',
    'selectedRecapAddition'
  ],
  mixins: [
    dateFormat,
  ],
  methods: {
    async deleteRecapAddition (id) {
      try {
        await RecapAdditions.delete(id)
      } catch (err) {
        this.$store.dispatch('setSnackbar', { status: 'alert', text: `Error Deleting Recap Addition: `, err })
      } finally {
        this.$store.dispatch('setSnackbar', { status: 'success', text: `Deleted Recap Aaddition Successfully` })
        this.$emit('close', true)
      }
    }
  }
}
</script>